<script lang="ts" setup>
const { inactive, createEmptyCart, restoreCart, getCart, cartStatus, placedOrderForQuoteCookie, getCartId } = useCart()
const { isLoggedIn } = useAccount()
const router = useRouter()
const restoreCartDialog = useUiDialog('restore-cart')
const status = ref()
const restored = ref()
const loading = ref<boolean>(false)

watch(inactive, async (newVal) => {
  if (!newVal) {
    return
  }

  status.value = await cartStatus(placedOrderForQuoteCookie.value || getCartId.value)
  if (status.value.group === 'restore') {
    restoreCartDialog.open()
  }
  else if (
    ['error', 'success', 'fix'].includes(status.value.group)
    || (status.value.group === 'login' && !isLoggedIn.value)
  ) {
    await createEmptyCart()
  }
})

const proceed = async () => {
  loading.value = true
  await createEmptyCart()
  restoreCartDialog.close()
  placedOrderForQuoteCookie.value = null
  await router.replace('/')
}

const closeDialog = async () => {
  if (!restored.value && !loading.value) {
    await createEmptyCart()
    await router.replace('/')
  }
}

const restore = async () => {
  loading.value = true
  restored.value = await restoreCart(placedOrderForQuoteCookie.value || getCartId.value || '')
  if (restored.value) {
    await getCart({ force: true })
    placedOrderForQuoteCookie.value = null
    restoreCartDialog.close()
  }
  else {
    await proceed()
  }
}
</script>

<template>
  <UiDialog
    class="restore-cart"
    name="restore-cart"
    dialog-type="modal"
    @close="closeDialog()"
  >
    <template #dialogHeader>
      <NuxtIcon name="icon:shoppingcart" />
      <span class="dialog__title">
        {{ $t('The payment has been cancelled') }}
      </span>
    </template>

    <!-- <p>{{ $t('Cart not active explanation') }}</p> -->

    <div class="restore-cart__buttons">
      <button
        type="button"
        class="restore-cart__button"
        :disabled="loading"
        @click="proceed()"
      >
        <span>{{ $t('Proceed') }}</span>
      </button>

      <button
        type="button"
        class="restore-cart__button"
        :disabled="loading"
        @click="restore()"
      >
        <span>{{ $t('Proceed to payment') }}</span>
      </button>
    </div>
  </UiDialog>
</template>

<style>
@import url("~layers/components/Cart/Restore.css");
</style>
